import React, { useEffect, useState } from 'react'

import InsightsMatrixListPopover from './InsightsMatrixListPopover'
import InsightsMatrixMemberPopover from './InsightsMatrixMemberPopover'
import Popover from '../Popover'
import { IMemberPlot } from './InsightsMatrix'
import { ICompanyMember, ICompanyTerm } from '../../common/models/Company'

interface IProps {
  anchor: HTMLElement | null
  isOpen: boolean
  placement?: 'left' | 'right'
  members: ICompanyMember[]
  plotByMemberId: Map<string, IMemberPlot>
  plotByMemberIdPrev?: Map<string, IMemberPlot>
  compareActive?: boolean
  selectedTerm?: ICompanyTerm
  compareTo?: ICompanyTerm
  segmentLabel?: string
  onClose: () => void
  onShowDetails?: (member: ICompanyMember) => void
  onMemberHover?: (memberId: string | undefined) => void
}

const InsightsClusterPopover: React.FC<IProps> = ({
  anchor,
  isOpen,
  placement,
  members,
  plotByMemberId,
  plotByMemberIdPrev,
  compareActive,
  selectedTerm,
  compareTo,
  segmentLabel,
  onClose,
  onShowDetails,
  onMemberHover,
}) => {
  const [inlineMemberId, setInlineMemberId] = useState<string>()

  useEffect(() => {
    if (!isOpen) {
      setInlineMemberId(undefined)
      onMemberHover?.(undefined)
    }
  }, [isOpen, onMemberHover])

  const inlineMember = inlineMemberId
    ? members.find((m) => m._id === inlineMemberId)
    : null
  const inlinePlot = inlineMemberId
    ? plotByMemberId.get(inlineMemberId)
    : undefined
  const inlinePlotPrev =
    inlineMemberId && plotByMemberIdPrev
      ? plotByMemberIdPrev.get(inlineMemberId)
      : undefined

  return (
    <Popover
      anchor={anchor}
      isOpen={isOpen}
      placement={placement}
      onClose={onClose}
    >
      {inlineMember && inlinePlot ? (
        <InsightsMatrixMemberPopover
          member={inlineMember}
          cultureScore={inlinePlot.x}
          skillScore={100 - inlinePlot.y}
          cultureAssessed={inlinePlot.cultureAssessed}
          skillAssessed={inlinePlot.skillAssessed}
          previousCultureScore={
            inlinePlotPrev?.cultureAssessed ? inlinePlotPrev.x : undefined
          }
          previousSkillScore={
            inlinePlotPrev?.skillAssessed ? 100 - inlinePlotPrev.y : undefined
          }
          compareActive={compareActive}
          selectedTerm={selectedTerm}
          compareTo={compareTo}
          onClose={onClose}
          onBack={() => {
            setInlineMemberId(undefined)
            onMemberHover?.(undefined)
          }}
          onShowDetails={
            onShowDetails
              ? () => {
                  onShowDetails(inlineMember)
                  onClose()
                }
              : undefined
          }
        />
      ) : (
        <InsightsMatrixListPopover
          members={members}
          segmentLabel={segmentLabel}
          onSelectMember={(m) => {
            setInlineMemberId(m._id)
            onMemberHover?.(m._id)
          }}
          onMemberHover={onMemberHover}
          onClose={onClose}
        />
      )}
    </Popover>
  )
}

export default InsightsClusterPopover
